/**
 * Platform Types and Interfaces
 * Defines data structures for platform selection and datasources
 */

export type PlatformType = 'salesforce' | 'sap' | 'odoo' | 'all';

export interface Platform {
  id: PlatformType;
  name: string;
  displayName: string;
  logo: string;
  color: string;
  available: boolean;
  datasourceId?: string;

  // Connection metadata
  connectionStatus?: 'active' | 'inactive' | 'error' | 'syncing';
  lastSyncAt?: Date | string;
  lastSyncStatus?: 'success' | 'error' | 'pending';
  connectionName?: string;
  errorMessage?: string;
  metadata?: {
    totalQueries?: number;
    avgResponseTime?: number;
  };
}

export interface Datasource {
  id: string;
  name: string;
  type: 'salesforce' | 'sap_erp' | 'odoo';
  status: 'active' | 'inactive' | 'error' | 'syncing';
  description?: string;
  connection_config?: any;
  last_sync_at?: string;
  last_sync_status?: string;
  last_sync_error?: string;
  total_queries?: number;
  total_errors?: number;
  avg_response_time_ms?: number;
  allowed_roles?: string[];
  sync_enabled?: boolean;
  sync_frequency_minutes?: number;
  created_at?: string;
  updated_at?: string;
}

export const PLATFORM_COLORS = {
  salesforce: {
    primary: '#00A1E0',
    light: '#E6F4F9',
    gradient: 'from-blue-500 to-cyan-600'
  },
  sap: {
    primary: '#0F75BD',
    light: '#E5F2FB',
    gradient: 'from-blue-600 to-blue-700'
  },
  odoo: {
    primary: '#714B67',
    light: '#F3EDF2',
    gradient: 'from-purple-600 to-purple-700'
  },
  all: {
    primary: '#06b6d4', // Cyan (app theme)
    light: '#ecfeff',
    gradient: 'from-cyan-500 to-cyan-600'
  }
} as const;

export interface PlatformCardProps {
  platform: Platform;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export interface PlatformSelectorProps {
  isCollapsed: boolean;
  onToggle: () => void;
  platforms: Platform[];
  selectedPlatforms: PlatformType[];
  onPlatformSelect: (platformId: PlatformType) => void;
  loading?: boolean;
  error?: string | null;
}
